/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AttachmentTypeResponse } from '../models/attachment-type-response';
import { BaseResponse } from '../models/base-response';
import { commonControllerGetAgreementCreationConfiguration } from '../fn/common/common-controller-get-agreement-creation-configuration';
import { CommonControllerGetAgreementCreationConfiguration$Params } from '../fn/common/common-controller-get-agreement-creation-configuration';
import { commonControllerGetAllKeys } from '../fn/common/common-controller-get-all-keys';
import { CommonControllerGetAllKeys$Params } from '../fn/common/common-controller-get-all-keys';
import { commonControllerGetAttachmentTypes } from '../fn/common/common-controller-get-attachment-types';
import { CommonControllerGetAttachmentTypes$Params } from '../fn/common/common-controller-get-attachment-types';
import { commonControllerGetScheduleConfiguration } from '../fn/common/common-controller-get-schedule-configuration';
import { CommonControllerGetScheduleConfiguration$Params } from '../fn/common/common-controller-get-schedule-configuration';
import { commonControllerGetUnits } from '../fn/common/common-controller-get-units';
import { CommonControllerGetUnits$Params } from '../fn/common/common-controller-get-units';
import { commonControllerSetAgreementCreationConfiguration } from '../fn/common/common-controller-set-agreement-creation-configuration';
import { CommonControllerSetAgreementCreationConfiguration$Params } from '../fn/common/common-controller-set-agreement-creation-configuration';
import { commonControllerSetScheduleConfiguration } from '../fn/common/common-controller-set-schedule-configuration';
import { CommonControllerSetScheduleConfiguration$Params } from '../fn/common/common-controller-set-schedule-configuration';
import { StatusWorkflowReplaceConfigurationResponse } from '../models/status-workflow-replace-configuration-response';
import { UnitsOfMeasureListResponse } from '../models/units-of-measure-list-response';

@Injectable({ providedIn: 'root' })
export class CommonService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `commonControllerGetUnits()` */
  static readonly CommonControllerGetUnitsPath = '/common/units-of-measure';

  /**
   * Restituisce l'elenco delle unità di misura.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerGetUnits()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetUnits$Response(params?: CommonControllerGetUnits$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UnitsOfMeasureListResponse;
}>> {
    return commonControllerGetUnits(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle unità di misura.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerGetUnits$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetUnits(params?: CommonControllerGetUnits$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UnitsOfMeasureListResponse;
}> {
    return this.commonControllerGetUnits$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UnitsOfMeasureListResponse;
}>): BaseResponse & {
'data'?: UnitsOfMeasureListResponse;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerGetAttachmentTypes()` */
  static readonly CommonControllerGetAttachmentTypesPath = '/common/attachment-types/{type}';

  /**
   * Restituisce l'elenco degli allegati che possono essere legati ad un evento del workflow.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerGetAttachmentTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetAttachmentTypes$Response(params: CommonControllerGetAttachmentTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AttachmentTypeResponse;
}>> {
    return commonControllerGetAttachmentTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli allegati che possono essere legati ad un evento del workflow.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerGetAttachmentTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetAttachmentTypes(params: CommonControllerGetAttachmentTypes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AttachmentTypeResponse;
}> {
    return this.commonControllerGetAttachmentTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AttachmentTypeResponse;
}>): BaseResponse & {
'data'?: AttachmentTypeResponse;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerGetAllKeys()` */
  static readonly CommonControllerGetAllKeysPath = '/common/keys/{entityTypeId}';

  /**
   * Restituisce le chiavi di sostituzione per le email dinamiche.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerGetAllKeys()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetAllKeys$Response(params: CommonControllerGetAllKeys$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowReplaceConfigurationResponse;
}>> {
    return commonControllerGetAllKeys(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce le chiavi di sostituzione per le email dinamiche.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerGetAllKeys$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetAllKeys(params: CommonControllerGetAllKeys$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: StatusWorkflowReplaceConfigurationResponse;
}> {
    return this.commonControllerGetAllKeys$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowReplaceConfigurationResponse;
}>): BaseResponse & {
'data'?: StatusWorkflowReplaceConfigurationResponse;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerGetScheduleConfiguration()` */
  static readonly CommonControllerGetScheduleConfigurationPath = '/common/sendScheduleMailConfiguration';

  /**
   * Restituisce la configurazione di base per l'invio mail delle schedulazioni.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerGetScheduleConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetScheduleConfiguration$Response(params?: CommonControllerGetScheduleConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: string;
}>> {
    return commonControllerGetScheduleConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce la configurazione di base per l'invio mail delle schedulazioni.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerGetScheduleConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetScheduleConfiguration(params?: CommonControllerGetScheduleConfiguration$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: string;
}> {
    return this.commonControllerGetScheduleConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: string;
}>): BaseResponse & {
'data'?: string;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerSetScheduleConfiguration()` */
  static readonly CommonControllerSetScheduleConfigurationPath = '/common/sendScheduleMailConfiguration';

  /**
   * Modifica o crea la configurazione di base per l'invio mail delle schedulazioni.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerSetScheduleConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerSetScheduleConfiguration$Response(params: CommonControllerSetScheduleConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: string;
}>> {
    return commonControllerSetScheduleConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica o crea la configurazione di base per l'invio mail delle schedulazioni.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerSetScheduleConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerSetScheduleConfiguration(params: CommonControllerSetScheduleConfiguration$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: string;
}> {
    return this.commonControllerSetScheduleConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: string;
}>): BaseResponse & {
'data'?: string;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerGetAgreementCreationConfiguration()` */
  static readonly CommonControllerGetAgreementCreationConfigurationPath = '/common/sendAgreementCreationMailConfiguration';

  /**
   * Restituisce la configurazione di base per l'invio mail all'apertura commessa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerGetAgreementCreationConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetAgreementCreationConfiguration$Response(params?: CommonControllerGetAgreementCreationConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: string;
}>> {
    return commonControllerGetAgreementCreationConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce la configurazione di base per l'invio mail all'apertura commessa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerGetAgreementCreationConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetAgreementCreationConfiguration(params?: CommonControllerGetAgreementCreationConfiguration$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: string;
}> {
    return this.commonControllerGetAgreementCreationConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: string;
}>): BaseResponse & {
'data'?: string;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerSetAgreementCreationConfiguration()` */
  static readonly CommonControllerSetAgreementCreationConfigurationPath = '/common/sendAgreementCreationMailConfiguration';

  /**
   * Modifica o crea la configurazione di base per l'invio mail all'apertura commessa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerSetAgreementCreationConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerSetAgreementCreationConfiguration$Response(params: CommonControllerSetAgreementCreationConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: string;
}>> {
    return commonControllerSetAgreementCreationConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica o crea la configurazione di base per l'invio mail all'apertura commessa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerSetAgreementCreationConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerSetAgreementCreationConfiguration(params: CommonControllerSetAgreementCreationConfiguration$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: string;
}> {
    return this.commonControllerSetAgreementCreationConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: string;
}>): BaseResponse & {
'data'?: string;
} => r.body)
    );
  }

}
